(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c5-ratio-vault"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cfscInit) return;
  window.__cfscInit = true;
  var toast, tm;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function getToast(root) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cfsc-toast';
      toast.addEventListener('click', function (e) { if (e.target.classList.contains('cfsc-toast-x') || e.target.classList.contains('cfsc-toast-keep')) toast.classList.remove('on'); });
    }
    if (root && toast.parentNode !== root) root.appendChild(toast);
    return toast;
  }
  function show(root, html) {
    var t = getToast(root);
    t.innerHTML = html;
    t.classList.add('on');
    clearTimeout(tm);
    tm = setTimeout(function () { t.classList.remove('on'); }, 10000);
  }
  function panel(root, added, cart) {
    var fa = root.getAttribute('data-free');
    var free = (fa === null || fa === '') ? 9900 : parseInt(fa, 10);
    var h = '<button type="button" class="cfsc-toast-x" aria-label="Close">&times;</button>';
    var t = cart && typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : null;
    var msg = (t === null || free <= 0) ? 'Added.' : (t >= free ? 'Added. Free US shipping unlocked.' : 'Added. You\'re ' + money(free - t) + ' from free US shipping.');
    h += '<div class="cfsc-toast-h"><span>' + esc(msg) + '</span></div>';
    if (t !== null && free > 0 && t < free) h += '<div class="cfsc-toast-bar"><i style="width:' + Math.round(100 * t / free) + '%"></i></div>';
    h += '<div class="cfsc-toast-act"><a class="cfsc-toast-view" href="/cart">View cart</a><button type="button" class="cfsc-toast-keep">Keep shopping</button></div>';
    return h;
  }
  function notifyTheme(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var def = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'c5-showcase', lines: [], promise: def.promise }));
        def.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'c5-showcase' } });
      }).catch(function () {});
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cfsc-form')) return;
    e.preventDefault();
    var root = f.closest('.cfsc');
    var btn = f.querySelector('button');
    var old = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(f.querySelector('[name=id]').value), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.disabled = false;
        if (d && d.id) {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          setTimeout(function () { btn.textContent = old; btn.classList.remove('is-added'); }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            notifyTheme(c);
            show(root, panel(root, String(d.product_title), c));
          });
        }
        btn.textContent = old;
        show(root, '<div class="cfsc-toast-h">' + esc((d && d.description) || 'Could not add to cart') + '</div>');
      })
      .catch(function () { btn.disabled = false; btn.textContent = old; f.submit(); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cfsc-go]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-cfsc-go'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
(function(){
  if (window.__cfuInit) return; window.__cfuInit = true;
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var els=document.querySelectorAll('[data-cfu-foc]');
    for(var i=0;i<els.length;i++){
      var el=els[i], end=new Date(el.getAttribute('data-cfu-foc')), ms=end-new Date();
      var q=function(u){return el.querySelector('[data-u="'+u+'"]');};
      if(isNaN(ms)) continue;
      if(ms<=0){q('d').textContent=q('h').textContent=q('m').textContent=q('s').textContent='00';continue;}
      q('d').textContent=pad(Math.floor(ms/864e5));q('h').textContent=pad(Math.floor(ms%864e5/36e5));q('m').textContent=pad(Math.floor(ms%36e5/6e4));q('s').textContent=pad(Math.floor(ms%6e4/1e3));
    }
  }
  function init(){tick();setInterval(tick,1000);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c5-showcase-issues"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cfscInit) return;
  window.__cfscInit = true;
  var toast, tm;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function getToast(root) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cfsc-toast';
      toast.addEventListener('click', function (e) { if (e.target.classList.contains('cfsc-toast-x') || e.target.classList.contains('cfsc-toast-keep')) toast.classList.remove('on'); });
    }
    if (root && toast.parentNode !== root) root.appendChild(toast);
    return toast;
  }
  function show(root, html) {
    var t = getToast(root);
    t.innerHTML = html;
    t.classList.add('on');
    clearTimeout(tm);
    tm = setTimeout(function () { t.classList.remove('on'); }, 10000);
  }
  function panel(root, added, cart) {
    var free = parseInt(root.getAttribute('data-free'), 10) || 9900;
    var h = '<button type="button" class="cfsc-toast-x" aria-label="Close">&times;</button>';
    var t = cart && typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : null;
    var msg = t === null ? 'Added.' : (t >= free ? 'Added. Free US shipping unlocked.' : 'Added. You\'re ' + money(free - t) + ' from free US shipping.');
    h += '<div class="cfsc-toast-h"><span>' + esc(msg) + '</span></div>';
    if (t !== null && t < free) h += '<div class="cfsc-toast-bar"><i style="width:' + Math.round(100 * t / free) + '%"></i></div>';
    h += '<div class="cfsc-toast-act"><a class="cfsc-toast-view" href="/cart">View cart</a><button type="button" class="cfsc-toast-keep">Keep shopping</button></div>';
    return h;
  }
  function notifyTheme(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var def = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'c5-showcase', lines: [], promise: def.promise }));
        def.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'c5-showcase' } });
      }).catch(function () {});
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cfsc-form')) return;
    e.preventDefault();
    var root = f.closest('.cfsc');
    var btn = f.querySelector('button');
    var old = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(f.querySelector('[name=id]').value), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.disabled = false;
        if (d && d.id) {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          setTimeout(function () { btn.textContent = old; btn.classList.remove('is-added'); }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            notifyTheme(c);
            show(root, panel(root, String(d.product_title).replace(/ [\u2014-] PREORDER/, '') + ' ' + (d.variant_title || '').replace(/ \(.*\)$/, ''), c));
          });
        }
        btn.textContent = old;
        show(root, '<div class="cfsc-toast-h">' + esc((d && d.description) || 'Could not add to cart') + '</div>');
      })
      .catch(function () { btn.disabled = false; btn.textContent = old; f.submit(); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cfsc-go]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-cfsc-go'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function countdown() {
    var els = document.querySelectorAll('[data-cfsc-foc]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = new Date(el.getAttribute('data-cfsc-foc'));
      var out = el.querySelector('[data-cfsc-left]');
      var ms = end - new Date();
      if (isNaN(ms) || !out) continue;
      if (ms <= 0) { out.textContent = 'Orders closed'; continue; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      out.textContent = 'Closes in ' + (d > 0 ? d + (d === 1 ? ' day ' : ' days ') + h + ' hrs' : h + ' hrs ' + m + ' min');
    }
  }
  function init() { countdown(); setInterval(countdown, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c5-showcase-otgw"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cfscInit) return;
  window.__cfscInit = true;
  var toast, tm;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function getToast(root) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cfsc-toast';
      toast.addEventListener('click', function (e) { if (e.target.classList.contains('cfsc-toast-x') || e.target.classList.contains('cfsc-toast-keep')) toast.classList.remove('on'); });
    }
    if (root && toast.parentNode !== root) root.appendChild(toast);
    return toast;
  }
  function show(root, html) {
    var t = getToast(root);
    t.innerHTML = html;
    t.classList.add('on');
    clearTimeout(tm);
    tm = setTimeout(function () { t.classList.remove('on'); }, 10000);
  }
  function panel(root, added, cart) {
    var fa = root.getAttribute('data-free');
    var free = (fa === null || fa === '') ? 9900 : parseInt(fa, 10);
    var h = '<button type="button" class="cfsc-toast-x" aria-label="Close">&times;</button>';
    var t = cart && typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : null;
    var msg = (t === null || free <= 0) ? 'Added.' : (t >= free ? 'Added. Free US shipping unlocked.' : 'Added. You\'re ' + money(free - t) + ' from free US shipping.');
    h += '<div class="cfsc-toast-h"><span>' + esc(msg) + '</span></div>';
    if (t !== null && free > 0 && t < free) h += '<div class="cfsc-toast-bar"><i style="width:' + Math.round(100 * t / free) + '%"></i></div>';
    h += '<div class="cfsc-toast-act"><a class="cfsc-toast-view" href="/cart">View cart</a><button type="button" class="cfsc-toast-keep">Keep shopping</button></div>';
    return h;
  }
  function notifyTheme(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var def = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'c5-showcase', lines: [], promise: def.promise }));
        def.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'c5-showcase' } });
      }).catch(function () {});
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cfsc-form')) return;
    e.preventDefault();
    var root = f.closest('.cfsc');
    var btn = f.querySelector('button');
    var old = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(f.querySelector('[name=id]').value), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.disabled = false;
        if (d && d.id) {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          setTimeout(function () { btn.textContent = old; btn.classList.remove('is-added'); }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            notifyTheme(c);
            show(root, panel(root, String(d.product_title).replace(/ [\u2014-] PREORDER/, '') + ' ' + (d.variant_title || '').replace(/ \(.*\)$/, ''), c));
          });
        }
        btn.textContent = old;
        show(root, '<div class="cfsc-toast-h">' + esc((d && d.description) || 'Could not add to cart') + '</div>');
      })
      .catch(function () { btn.disabled = false; btn.textContent = old; f.submit(); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cfsc-go]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-cfsc-go'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function countdown() {
    var els = document.querySelectorAll('[data-cfsc-foc]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = new Date(el.getAttribute('data-cfsc-foc'));
      var out = el.querySelector('[data-cfsc-left]');
      var ms = end - new Date();
      if (isNaN(ms) || !out) continue;
      if (ms <= 0) { out.textContent = 'Orders closed'; continue; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      out.textContent = 'Closes in ' + (d > 0 ? d + (d === 1 ? ' day ' : ' days ') + h + ' hrs' : h + ' hrs ' + m + ' min');
    }
  }
  function init() { countdown(); setInterval(countdown, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c5-showcase-ufo"] && !Shopify.designMode) return;
  try {
    

(function () {
  if (window.__cfscInit) return;
  window.__cfscInit = true;
  var toast, tm;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function getToast(root) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cfsc-toast';
      toast.addEventListener('click', function (e) { if (e.target.classList.contains('cfsc-toast-x') || e.target.classList.contains('cfsc-toast-keep')) toast.classList.remove('on'); });
    }
    if (root && toast.parentNode !== root) root.appendChild(toast);
    return toast;
  }
  function show(root, html) {
    var t = getToast(root);
    t.innerHTML = html;
    t.classList.add('on');
    clearTimeout(tm);
    tm = setTimeout(function () { t.classList.remove('on'); }, 10000);
  }
  function panel(root, added, cart) {
    var fa = root.getAttribute('data-free');
    var free = (fa === null || fa === '') ? 9900 : parseInt(fa, 10);
    var h = '<button type="button" class="cfsc-toast-x" aria-label="Close">&times;</button>';
    var t = cart && typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : null;
    var msg = (t === null || free <= 0) ? 'Added.' : (t >= free ? 'Added. Free US shipping unlocked.' : 'Added. You\'re ' + money(free - t) + ' from free US shipping.');
    h += '<div class="cfsc-toast-h"><span>' + esc(msg) + '</span></div>';
    if (t !== null && free > 0 && t < free) h += '<div class="cfsc-toast-bar"><i style="width:' + Math.round(100 * t / free) + '%"></i></div>';
    h += '<div class="cfsc-toast-act"><a class="cfsc-toast-view" href="/cart">View cart</a><button type="button" class="cfsc-toast-keep">Keep shopping</button></div>';
    return h;
  }
  function notifyTheme(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var def = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'c5-showcase', lines: [], promise: def.promise }));
        def.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'c5-showcase' } });
      }).catch(function () {});
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cfsc-form')) return;
    e.preventDefault();
    var root = f.closest('.cfsc');
    var btn = f.querySelector('button');
    var old = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(f.querySelector('[name=id]').value), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.disabled = false;
        if (d && d.id) {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          setTimeout(function () { btn.textContent = old; btn.classList.remove('is-added'); }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            notifyTheme(c);
            show(root, panel(root, String(d.product_title).replace(/ [\u2014-] PREORDER/, '') + ' ' + (d.variant_title || '').replace(/ \(.*\)$/, ''), c));
          });
        }
        btn.textContent = old;
        show(root, '<div class="cfsc-toast-h">' + esc((d && d.description) || 'Could not add to cart') + '</div>');
      })
      .catch(function () { btn.disabled = false; btn.textContent = old; f.submit(); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cfsc-go]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-cfsc-go'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function countdown() {
    var els = document.querySelectorAll('[data-cfsc-foc]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = new Date(el.getAttribute('data-cfsc-foc'));
      var out = el.querySelector('[data-cfsc-left]');
      var ms = end - new Date();
      if (isNaN(ms) || !out) continue;
      if (ms <= 0) { out.textContent = 'Orders closed'; continue; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      out.textContent = 'Closes in ' + (d > 0 ? d + (d === 1 ? ' day ' : ' days ') + h + ' hrs' : h + ' hrs ' + m + ' min');
    }
  }
  function init() { countdown(); setInterval(countdown, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

(function(){
  if (window.__cfuInit) return; window.__cfuInit = true;
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var els=document.querySelectorAll('[data-cfu-foc]');
    for(var i=0;i<els.length;i++){
      var el=els[i], end=new Date(el.getAttribute('data-cfu-foc')), ms=end-new Date();
      var q=function(u){return el.querySelector('[data-u="'+u+'"]');};
      if(isNaN(ms)) continue;
      if(ms<=0){q('d').textContent=q('h').textContent=q('m').textContent=q('s').textContent='00';continue;}
      q('d').textContent=pad(Math.floor(ms/864e5));q('h').textContent=pad(Math.floor(ms%864e5/36e5));q('m').textContent=pad(Math.floor(ms%36e5/6e4));q('s').textContent=pad(Math.floor(ms%6e4/1e3));
    }
  }
  function init(){tick();setInterval(tick,1000);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c5-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cfscInit) return;
  window.__cfscInit = true;
  var toast, tm;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function getToast(root) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cfsc-toast';
      toast.addEventListener('click', function (e) { if (e.target.classList.contains('cfsc-toast-x') || e.target.classList.contains('cfsc-toast-keep')) toast.classList.remove('on'); });
    }
    if (root && toast.parentNode !== root) root.appendChild(toast);
    return toast;
  }
  function show(root, html) {
    var t = getToast(root);
    t.innerHTML = html;
    t.classList.add('on');
    clearTimeout(tm);
    tm = setTimeout(function () { t.classList.remove('on'); }, 10000);
  }
  function panel(root, added, cart) {
    var fa = root.getAttribute('data-free');
    var free = (fa === null || fa === '') ? 9900 : parseInt(fa, 10);
    var h = '<button type="button" class="cfsc-toast-x" aria-label="Close">&times;</button>';
    var t = cart && typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : null;
    var msg = (t === null || free <= 0) ? 'Added.' : (t >= free ? 'Added. Free US shipping unlocked.' : 'Added. You\'re ' + money(free - t) + ' from free US shipping.');
    h += '<div class="cfsc-toast-h"><span>' + esc(msg) + '</span></div>';
    if (t !== null && free > 0 && t < free) h += '<div class="cfsc-toast-bar"><i style="width:' + Math.round(100 * t / free) + '%"></i></div>';
    h += '<div class="cfsc-toast-act"><a class="cfsc-toast-view" href="/cart">View cart</a><button type="button" class="cfsc-toast-keep">Keep shopping</button></div>';
    return h;
  }
  function notifyTheme(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var def = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'c5-showcase', lines: [], promise: def.promise }));
        def.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'c5-showcase' } });
      }).catch(function () {});
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cfsc-form')) return;
    e.preventDefault();
    var root = f.closest('.cfsc');
    var btn = f.querySelector('button');
    var old = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(f.querySelector('[name=id]').value), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.disabled = false;
        if (d && d.id) {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          setTimeout(function () { btn.textContent = old; btn.classList.remove('is-added'); }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            notifyTheme(c);
            show(root, panel(root, String(d.product_title).replace(/ [\u2014-] PREORDER/, '') + ' ' + (d.variant_title || '').replace(/ \(.*\)$/, ''), c));
          });
        }
        btn.textContent = old;
        show(root, '<div class="cfsc-toast-h">' + esc((d && d.description) || 'Could not add to cart') + '</div>');
      })
      .catch(function () { btn.disabled = false; btn.textContent = old; f.submit(); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cfsc-go]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-cfsc-go'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function countdown() {
    var els = document.querySelectorAll('[data-cfsc-foc]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = new Date(el.getAttribute('data-cfsc-foc'));
      var out = el.querySelector('[data-cfsc-left]');
      var ms = end - new Date();
      if (isNaN(ms) || !out) continue;
      if (ms <= 0) { out.textContent = 'Orders closed'; continue; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      out.textContent = 'Closes in ' + (d > 0 ? d + (d === 1 ? ' day ' : ' days ') + h + ' hrs' : h + ' hrs ' + m + ' min');
    }
  }
  function init() { countdown(); setInterval(countdown, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
